var map = {
	"./en-gb": 2643
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2642;



//////////////////
// WEBPACK FOOTER
// ../~/moment/locale ^\.\/(en-gb|en-us)$
// module id = 2642
// module chunks = 3